import { EnvProvider } from '@zenbusiness/application-commons-env';

import ClickstreamWrapper from '#client/ClickstreamWrapper';
import BusinessEntityGate from '#client/components/BusinessEntityGate';
import BoAModalContent from '#client/components/OpenAccountApplication/components/Steps/ValidationMessage/components/BoAModalContent';
import { OrderTaskProvider } from '#client/hooks/useOrderTaskContext';
import { ToastProvider } from '#client/hooks/useToastContext';
import AppWrapper from '#client/Providers';

const ENV = process.env.BUILD_ENV;

export default function BankOfAmericaOfferModalEntry() {
  return (
    <EnvProvider env={ENV}>
      <EnvProvider env={`${ENV.DEFAULT_SEGMENT}/env?v=${ENV.RELEASE_VERSION}`}>
        <AppWrapper federated>
          <ClickstreamWrapper>
            <BusinessEntityGate>
              <ToastProvider>
                <OrderTaskProvider>
                  <BoAModalContent />
                </OrderTaskProvider>
              </ToastProvider>
            </BusinessEntityGate>
          </ClickstreamWrapper>
        </AppWrapper>
      </EnvProvider>
    </EnvProvider>
  );
}
